import React from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { Spin } from 'antd';
import { useAuth } from './AuthContext';
import NoRoleAccessPage from '../Pages/AccessDenied/NoRoleAccessPage';

/**
 * Layout route: spinner while auth or role resolves; redirect to `/login` if anonymous;
 * block with {@link NoRoleAccessPage} if authenticated without a role.
 */
export function RequireAuth() {
    const { user, loading, roleLoading, roleDenied } = useAuth();
    const location = useLocation();

    if (loading) {
        return (
            <div className="auth-gate-loading" role="status" aria-live="polite">
                <Spin size="large" tip="Signing in…" />
            </div>
        );
    }

    if (!user) {
        return <Navigate to="/login" replace state={{ from: location }} />;
    }

    if (roleLoading) {
        return (
            <div className="auth-gate-loading" role="status" aria-live="polite">
                <Spin size="large" tip="Checking permissions…" />
            </div>
        );
    }

    if (roleDenied) {
        return <NoRoleAccessPage />;
    }

    return <Outlet />;
}
